var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModel = function SvgModel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#model_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 5.641A1.64 1.64 0 0 1 28.642 4h8.207a1.64 1.64 0 0 1 1.641 1.641v8.208a1.64 1.64 0 0 1-1.641 1.641h-8.207A1.64 1.64 0 0 1 27 13.85zM6 23.353h21.708a3.62 3.62 0 0 1 3.618 3.618v5.427a3.62 3.62 0 0 1-3.618 3.617H9.618A3.62 3.62 0 0 1 6 32.399v-18.09a3.62 3.62 0 0 1 3.618-3.618h5.427a3.62 3.62 0 0 1 3.618 3.618v21.708"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "model_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v42H0z"
  })))));
};
export default SvgModel;